import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PODAction } from "../../_store/pod.slice";
import { CheckBoxInput } from "../../components/common/ui/Inputs";
import { history } from "../../_helpers";

const ACCESS_KEYS = [
  "MessageAcess",
  "PhotoAccess",
  "EcardAccess",
  "FormReqAccess",
  "DocumentsAccess",
  "PostalMailAccess",
  "CommissaryAccess",
  "LawLibraryAccess",
  "DisplayCurrentDate",
];

const AccessPermission = () => {
  const dispatch = useDispatch();
  const { commonFacilityCode: facilityCode } = useSelector(
    (state) => state.auth
  );
  const GetFacilityInfoData = useSelector(
    (state) => state.pod.GetFacilityInfoData
  );

  const podData = useSelector((state) => state.pod?.managePODdata); // Access the form data from Redux
  const prevFacilityCodeRef = useRef(facilityCode); // Track previous value

  // Define access configurations
  const accessConfigs = [
    {
      key: "IsMessageAcess",
      label: "Allow Access to e-mail Messaging",
      name: "MessageAcess",
      info: "To allow the inmate to access the Messages from the specific pod",
    },
    {
      key: "IsPhotoAccess",
      label: "Allow Access to Photos",
      name: "PhotoAccess",
      info: "To allow the inmate to access the Photos from the specific pod",
    },
    {
      key: "IsEcardAccess",
      label: "Allow Access to E-Cards",
      name: "EcardAccess",
      info: "To allow the inmate to access the E-Cards from the specific pod",
    },
    {
      key: "IsFormReqAccess",
      label: "Allow Access to Request Forms",
      name: "FormReqAccess",
      info: "To allow the inmate to access the Request forms from the specific pod",
    },
    {
      key: "IsDocumentsAccess",
      label: "Allow Access to Document",
      name: "DocumentsAccess",
      info: "To allow the inmate to access the Documents from the specific pod",
    },
    {
      key: "IsMailScanningAccess",
      label: "Allow Access to Postal Mail",
      name: "PostalMailAccess",
      info: "To allow the inmate to access the Postal Mail from the specific pod",
    },
    {
      key: "IsCommissaryAccess",
      label: "Allow Access to Commissary",
      name: "CommissaryAccess",
      info: "To allow the inmate to access the Commissary from the specific pod",
    },
    {
      key: "IsLawLibraryAccess",
      label: "Allow Access to Law Library",
      name: "LawLibraryAccess",
      info: "To allow the inmate to access the Law Library from the specific pod",
    },
    {
      key: "DisplayCurrentDate",
      label: "Allow Access to Display Current Date",
      name: "DisplayCurrentDate",
      info: "To allow the inmate to access the Display Current Date from the specific pod",
    },
  ];

  // Dispatch the action when facilityID changes in loadManagementUser
  useEffect(() => {
    if (facilityCode) {
      dispatch(PODAction.GetFacilityAccessInfo(facilityCode))
        .then((response) => {
          // Handle success or error response here
        })
        .catch((error) => {
          console.error("Error loading POD list:", error);
          // Optionally show a notification to the user
        });
    }
    if (prevFacilityCodeRef.current !== facilityCode) {
      history.navigate("PODList");
    }
  }, [facilityCode, dispatch]);

  const handleManagementFormChange = (e) => {

    const { name, checked } = e.target;
    const value = checked ? 1 : 0; // Convert checked state to 1 or 0

    // Function to dispatch updated data to Redux
    const updatePODData = (updatedData) => {
      dispatch(PODAction.setPODListData(updatedData));
    };

    if (name === "managementSelectAll") {
      // Update all permissions if "Select All" is clicked
      const updatedForm = ACCESS_KEYS.reduce((acc, key) => {
        acc[key] = value;
        return acc;
      }, {});

      // Merge updatedForm with existing podData and dispatch
      updatePODData({ ...podData, ...updatedForm });
    } else {
      // Update specific permission based on checkbox name
      const updatedData = {
        ...podData,
        [name]: value,
      };

      updatePODData(updatedData); // Dispatch the updated object to Redux
    }
  };

  const filterData = () => {
    const filteredAccess = accessConfigs?.filter(
      (item, index) => GetFacilityInfoData[item?.key] === 1
    );

    const isAllActive = filteredAccess?.every(
      (item, index) => podData[item?.name] === 1
    );
    return isAllActive;
  };

  return (
    <>
      <h4 className="inner-header-bg text-color">
        <i className="fas fa-shield-alt me-2"></i>Access Permission
      </h4>
      <div className="p-2">
        <CheckBoxInput
          label="Select / Unselect All"
          name="managementSelectAll"
          id={"managementSelectAll"}
          handleClick={(e) => handleManagementFormChange(e)}
          checked={
            filterData()
            // podData.MessageAcess &&
            // podData.PhotoAccess &&
            // podData.EcardAccess &&
            // podData.FormReqAccess &&
            // podData.DocumentsAccess &&
            // podData.PostalMailAccess &&
            // podData.CommissaryAccess &&
            // podData.LawLibraryAccess &&
            // podData.DisplayCurrentDate
          }
        />

        {accessConfigs.map(({ key, label, name, info }) => {
          if (GetFacilityInfoData[key] === 1) {
            return (
              <div key={name} className="d-flex align-items-center">
                <CheckBoxInput
                  label={label}
                  name={name}
                  id={name}
                  handleClick={handleManagementFormChange}
                  checked={podData[name]}
                />
                <i
                  title={info}
                  className="fa fa-info-circle ms-1"
                  data-tooltip-id={`tooltip-${name}`}
                ></i>
              </div>
            );
          }
          return null; // Return null if the condition is not met
        })}
      </div>
    </>
  );
};

export default React.memo(AccessPermission);
